export const searchQuery = `query Search(
  $site: String!
  $keyword: String!
  $languageCode: String
  $userState: String
  $limit: Int
  $offset: Int
  $relatedSearch: Boolean
  $types: [String!]
) {
  search(
    site: $site
    keyword: $keyword
    languageCode: $languageCode
    userState: $userState
    limit: $limit
    offset: $offset
    relatedSearch: $relatedSearch
    types: $types
  ) {
    records {
      id
      title
      ... on Video {
        runtime
      }
      gist {
        id
        title
        permalink
        contentType
        description
        imageGist {
          r32x9
          r16x9
          r4x3
          r3x4
          r1x1
          r9x16
        }
      }
    }
    related {
      id
      title
      ... on Video {
        runtime
      }
      gist {
        id
        title
      }
    }
  }
}`;

export const minifiedSearchQuery = `query Search( $site: String! $keyword: String! $languageCode: String $userState: String $limit: Int $offset: Int $relatedSearch: Boolean $types: [String!] ) { search( site: $site keyword: $keyword languageCode: $languageCode userState: $userState limit: $limit offset: $offset relatedSearch: $relatedSearch types: $types ) { records { id title ... on Video { runtime } gist { id title permalink contentType description imageGist { r32x9 r16x9 r4x3 r3x4 r1x1 r9x16 } } } related { id title ... on Video { runtime } gist { id title } } } }`
export const searchQuerySHA = '7df9d0b9d3601351088a6d69d29f9e84338a143325f0e48bfb4ef3fa6c76c06f'